import React, { Component } from "react";
import { Row, Label, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import UserIcon1 from '../../../assets/user-image-plc/User_Icon_1.svg';
import UserIcon2 from '../../../assets/user-image-plc/User_Icon_2.svg';
import UserIcon3 from '../../../assets/user-image-plc/User_Icon_3.svg';
import UserIcon4 from '../../../assets/user-image-plc/User_Icon_4.svg';
import UserIcon5 from '../../../assets/user-image-plc/User_Icon_5.svg';
import './OfficeMateProfile.css';
import axios from '../../../axios';
import * as url from '../../../utils/url';
import ProfilePage from '../../user/ProfilePage'



export default class OfficeMateProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
        officeMate: undefined,
        profilePicSrcIndex: 0,
        menu:null
    }
  }

  
  componentDidUpdate(prevProps, prevState){
    // let current =  this.props.location.pathname
    // let{menu}=prevState
 
    let{match}=this.props

    if(match.url !== prevProps.match.url){
      let current =match.url,
      {menu}=this.state

      if( (current.includes('groups')||current.includes('skills'))  && menu!=2){
        this.setState({menu:2})
      }else if(current.includes('events') && menu!=3){
        this.setState({menu:3})
      } else if( (!current.includes('events') || current == '/home/profile') && menu!=1){ 
        this.setState({menu:1})
      } else if (current.includes("my-trivvys") && menu != 5) {
        this.setState({ menu: 5 });
      } else if (current.includes("pending-trivvys") && menu != 6) {
        this.setState({ menu: 6 });
      }else{
        this.setState({ menu: 1 });
      }
    }
    

  }

  componentWillMount() {

    if(this.props.location.state) {
        this.setState({officeMate: this.props.location.state.officeMate, profilePicSrcIndex: this.props.location.state.profilePicSrcIndex});
    } else {
      // console.log("profile page!!!")
      let id = this.props.match.params.id; 
      let org =this.props.match.params.orgId
      this.getUserDetails(id,org);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let id = this.props.match.params.id; 
    let org =this.props.match.params.orgId

    this.getUserDetails(id,org);
  }

  
  navigateToOfficeMates = () => {
    this.props.history.push('/home/users');
}

  getUserDetails = (id, org) => {
    axios.get(url.getUserProfile(id, org))
      .then((response) => {
        if (!response.data.data || response.data.data.status === "INACTIVE") {
          this.navigateToOfficeMates();
          return;
        }
        this.setState({ officeMate: response.data.data });
      })
      .catch((error) => {
        console.error("Error fetching user profile:", error);
        this.navigateToOfficeMates();
      });
  };

  renderContent=()=>{
    let{officeMate,menu}=this.state
    // return  <ProfilePage {...this.state.officeMate} member={this.state.officeMate} 
    // menu={menu}
    // profileEditSuccsess={this.handleProfileUpdateSuccess}/> 
    if(officeMate && officeMate._id){
      return  <ProfilePage {...this.state.officeMate} member={this.state.officeMate} 
      menu={menu}
      profileEditSuccsess={this.handleProfileUpdateSuccess}/> 
    } else {
      return <div> Loading... </div>
    }
  }

  render() {
      let {firstName, lastName, title, email, dIRole, profilePic, profilePicSrcIndex} = {...this.state.officeMate};
      let offcemateName = (firstName ? firstName : '') + (lastName ? (firstName? (' '+ lastName) : lastName) : '')
      let userPicPlaceholders = [UserIcon1, UserIcon2, UserIcon3, UserIcon4, UserIcon5];
    return this.renderContent()
    // <div className="ml50 ">
    //     <div className=""> 
    //       <Breadcrumb>
    //         <BreadcrumbItem>
    //           <a className="officemates-link" onClick={this.navigateToOfficeMates}>
    //           Enterprise Members
    //           </a>
    //         </BreadcrumbItem>
    //         <BreadcrumbItem active>
    //           <span className="officemate-name-breadcrumb">
    //             {offcemateName}
    //           </span>
    //         </BreadcrumbItem>
    //       </Breadcrumb>
    //     </div>
    //     <div className="mt30">
    //       <div className="row mlmr0">
    //         <Col sm={2} md={2} style={{ marginRight: '-15px', paddingLeft: '0px'}}>
    //           <img src={profilePic || userPicPlaceholders[this.state.profilePicSrcIndex]} className="officemate-profile-img" />
    //         </Col>
    //         <Col sm={10} md={10} className="">
    //           <Row>
    //             <span className="officemate-name">{offcemateName}</span>
    //           </Row>
    //         </Col>
    //       </div>
    //     </div>
    //     <div className="row mt40">
    //       <Col sm={2} className="text-right">
    //         <span className="officemate-label">Title</span>
    //       </Col>
    //       <Col sm={10} className="align-self-center">
    //         <span className="officemate-value">{title}</span>
    //       </Col>
    //     </div>
    //     <div className="row mt20">
    //       <Col sm={2} className="text-right">
    //         <span className="officemate-label">Email</span>
    //       </Col>
    //       <Col sm={10} className="align-self-center">
    //         <span className="officemate-value">{email}</span>
    //       </Col>
    //     </div>
    //     <div className="row mt20">
    //       <Col sm={2} className="text-right">
    //         <span className="officemate-label">DEI Role</span>
    //       </Col>
    //       <Col sm={10} className="align-self-center">
    //         <span className="officemate-value">{dIRole}</span>
    //       </Col>
    //     </div>
    //   </div>;
  }
}
